import { AxiosError } from 'axios';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import {
  BuyOrderType,
  SellOrderType,
} from 'global/Securities/types/transaction';
import { Response } from '../../../../@types/api-response';

// eslint-disable-next-line no-shadow
export enum AuthModalType {
  LOGIN = 'login',
  REGISTER = 'register',
  PROGRESS = 'progress',
}

// eslint-disable-next-line no-shadow
export enum AuthModalStatus {
  UNREGISTERED = 0,
  INCOMPLETE = 1,
  CS = 2,
  KSEI = 3,
  RDN = 4,
  REJECTED = 99,
  COMPLETED = 100,
}

export interface VirtualTradingButtonProps {
  title: string | ReactNode;
  type: AuthModalType;
  setLoading: Dispatch<SetStateAction<boolean>>;
}

export interface ITradingModalConfig {
  visible?: boolean;
  symbol?: string;
  price?: number;
  orderType?: string;
  showOrderbook?: boolean;
  showTabs?: boolean;
  showOrderType?: boolean;
  orderedLot?: number;
  orderid?: string;
  orderedPrice?: number;
  isAutoBuy?: boolean;
  isDayTrade?: boolean;
  modalData?: any;
  formType?: SellOrderType | BuyOrderType;
  setToMaxLot?: boolean;
  onRealLoginSuccess?: () => void;
  onVirtualLoginSuccess?: () => void;
}

export interface AuthModalStore {
  visible: boolean;
  tradingModalConfig?: ITradingModalConfig;
  showModal: (tradingModalConfig?: ITradingModalConfig) => void;
  closeModal: () => void;
}

export interface AuthModalProps {
  visible: boolean;
  onClose?: () => void;
}

export interface AuthTokenPayload {
  payload: {
    error?: AxiosError<Response>;
  };
}

export interface AuthPinPayload {
  payload: {
    error?: AxiosError<Response>;
    message?: string;
  };
}

export interface SwitchVirtualPayload {
  payload: {
    error?: AxiosError<Response>;
  };
}
